var _defs, _g, _g2, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeToTrainingBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 713,
    height: 370,
    viewBox: "0 0 713 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.914,
    x2: 1,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e5bda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ad6be0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb7ae6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.914,
    x2: 1,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45b649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dce35b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 713,
    height: 370,
    rx: 30,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.236,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.018,
    y2: 0.895,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: -0.188,
    y2: 0.873,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: -0.085,
    y2: 0.884,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.18,
    y2: 0.913,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.138,
    y2: 0.908,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: -0.046,
    y2: 0.889,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: -0.296,
    y2: 0.862,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: -0.116,
    y2: 0.881,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: -0.339,
    y2: 0.857,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 0.096,
    y2: 0.904,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: -0.24,
    y2: 0.868,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 0.039,
    y2: 0.898,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 0.123,
    y2: 0.907,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: -0.014,
    y2: 0.892,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 0.315,
    y2: 0.927,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.5,
    y1: -0.103,
    x2: 0.5,
    y2: 1.344,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.5,
    y1: 0.081,
    x2: 0.5,
    y2: 1.286,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.5,
    y1: -0.533,
    x2: 0.5,
    y2: 1.477,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.5,
    y1: -0.746,
    x2: 0.5,
    y2: 1.544,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.5,
    y1: 0.036,
    x2: 0.5,
    y2: 1.3,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.5,
    y1: 0.255,
    x2: 0.5,
    y2: 1.232,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.5,
    y1: -0.839,
    x2: 0.5,
    y2: 1.573,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.5,
    y1: 0.234,
    x2: 0.5,
    y2: 1.239,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.5,
    y1: -0.379,
    x2: 0.5,
    y2: 1.43,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.5,
    y1: -1.058,
    x2: 0.5,
    y2: 1.641,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.5,
    y1: -0.189,
    x2: 0.5,
    y2: 1.37,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.5,
    y1: -0.061,
    x2: 0.5,
    y2: 1.33,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.5,
    y1: -1.207,
    x2: 0.5,
    y2: 1.687,
    xlinkHref: "#linear-gradient-33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14285",
    "data-name": "Group 14285",
    transform: "translate(-354 -162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(354 162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-2",
    "data-name": "bg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg-3",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-4",
    "data-name": "bg",
    width: 713,
    height: 370,
    rx: 30,
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    clipPath: "url(#clipPath)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13132",
    "data-name": "Group 13132",
    transform: "translate(36.165 -94.755)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13129",
    "data-name": "Group 13129",
    transform: "translate(-41.157 48.298)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13127",
    "data-name": "Group 13127",
    transform: "translate(8.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 21.964,
    height: 430.208,
    transform: "translate(0 49.249)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 21.964,
    height: 334.463,
    transform: "translate(26.129 144.994)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 21.964,
    height: 276.498,
    transform: "translate(52.258 202.959)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 21.964,
    height: 302.686,
    transform: "translate(78.386 176.771)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 21.963,
    height: 400.746,
    transform: "translate(104.515 78.71)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 21.964,
    height: 334.463,
    transform: "translate(130.644 144.994)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 21.965,
    height: 381.253,
    transform: "translate(156.772 98.204)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 21.964,
    height: 314.146,
    transform: "translate(182.902 165.311)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 21.964,
    height: 253.585,
    transform: "translate(209.03 225.872)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 21.963,
    height: 294.502,
    transform: "translate(235.159 184.955)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 21.963,
    height: 245.398,
    transform: "translate(261.288 234.059)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 21.964,
    height: 314.146,
    transform: "translate(287.416 165.311)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 21.964,
    height: 334.463,
    transform: "translate(313.545 144.994)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 21.964,
    height: 276.498,
    transform: "translate(339.673 202.959)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 21.964,
    height: 334.463,
    transform: "translate(365.802 144.994)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 21.963,
    height: 363.248,
    transform: "translate(391.932 116.209)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 21.963,
    height: 314.146,
    transform: "translate(418.06 165.311)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 21.963,
    height: 265.04,
    transform: "translate(444.188 214.417)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 21.963,
    height: 245.398,
    transform: "translate(470.317 234.059)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 21.962,
    height: 302.686,
    transform: "translate(496.445 176.771)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 21.963,
    height: 363.248,
    transform: "translate(522.572 116.209)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 21.963,
    height: 381.253,
    transform: "translate(548.701 98.204)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 21.962,
    height: 341.97,
    transform: "translate(574.831 137.487)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 21.963,
    height: 374.703,
    transform: "translate(600.958 104.753)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 21.963,
    height: 265.04,
    transform: "translate(627.087 214.417)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 21.962,
    height: 323.966,
    transform: "translate(653.215 155.491)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 21.962,
    height: 363.248,
    transform: "translate(679.344 116.209)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 21.963,
    height: 302.686,
    transform: "translate(705.471 176.771)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 21.963,
    height: 374.703,
    transform: "translate(731.6 104.753)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 21.962,
    height: 479.457,
    transform: "translate(757.729)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13128",
    "data-name": "Group 13128",
    transform: "translate(0 224.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 42.906,
    height: 172.448,
    transform: "translate(0 82.824)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 42.905,
    height: 206.96,
    transform: "translate(52.559 48.312)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 42.905,
    height: 124.133,
    transform: "translate(105.118 131.138)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 42.906,
    height: 108.948,
    transform: "translate(157.677 146.324)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 42.905,
    height: 197.293,
    transform: "translate(210.236 57.979)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 42.906,
    height: 255.272,
    transform: "translate(262.794)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 42.906,
    height: 103.478,
    transform: "translate(315.353 151.794)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 42.905,
    height: 172.448,
    transform: "translate(367.912 82.824)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 42.907,
    height: 248.367,
    transform: "translate(420.47 6.905)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 42.903,
    height: 137.937,
    transform: "translate(473.031 117.334)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 42.906,
    height: 197.293,
    transform: "translate(525.588 57.979)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 42.906,
    height: 92.437,
    transform: "translate(578.147 162.835)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 42.905,
    height: 160.026,
    transform: "translate(630.706 95.245)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 42.906,
    height: 206.96,
    transform: "translate(683.264 48.312)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 42.905,
    height: 179.35,
    transform: "translate(735.824 75.922)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 42.905,
    height: 86.226,
    transform: "translate(788.383 169.046)",
    fill: "url(#linear-gradient-48)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14234",
    "data-name": "Group 14234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13978",
    "data-name": "Group 13978",
    transform: "translate(764.328 194.477)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60704",
    "data-name": "Path 60704",
    d: "M2031.031,1212.685a1.179,1.179,0,0,0,.274.031,1.291,1.291,0,0,0,1.244-.966h0l0-.007,0-.015q0-.01,0-.02v0c0-.005,0,0,0,0l.006-.012h0a2.159,2.159,0,0,0,.029-.264,1.271,1.271,0,0,0-.959-1.276,1.236,1.236,0,0,0-1.493.912c0,.006.014.01.014.016h0l-.021.008c0,.006-.012.011-.014.017s-.007-.014-.009-.009l-.013.02h0a2.261,2.261,0,0,0-.03.284A1.294,1.294,0,0,0,2031.031,1212.685Z",
    transform: "translate(-1957.763 -1172.999)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60705",
    "data-name": "Path 60705",
    d: "M1578.313,964.619l-4.488-11.249-3.04,1.378-.861-2.112-1.134.405c-1.516.542-14.856,5.313-16.358,6.055a2.966,2.966,0,0,0-1.511,1.655,4.434,4.434,0,0,0-3.206.2c-3.315,1.342-15.5,5.857-15.626,5.9l-1.229.455.82,1.967-3.207,1.143,10.516,25.217.2-.085-.15.624,2.859.686-1.238,5.594-1.52-.365-2.561,10.67,26.816,6.437-.874,3.64,5.4-1.253,4.2,4.161,1.057-4.2,14.986,3.6,1.453-6.052,5.389,1.294a1.272,1.272,0,0,0,.3.035,1.259,1.259,0,0,0,1.22-.956c.031-.127,3.172-12.794,5.894-24.138a1.259,1.259,0,0,0-2.448-.588c-2.229,9.288-4.739,19.465-5.59,22.907l-31.991-7.679,9.236-38.476a5.714,5.714,0,0,0,2.386,1.2l29.454,7.07-1.934,8.056a1.26,1.26,0,0,0,1.225,1.552,1.229,1.229,0,0,0,1.223-.932l1.943-8.064h0l.587-2.481-4.973-1.21a2.684,2.684,0,0,1-.351-2.277,1.9,1.9,0,0,1,1.07-1.444l4.407,1.056.01-.042.326.078.587-2.448L1603,970.5a2.855,2.855,0,0,0-.48-.072Zm-5.849-7.869,2.878,7.213a4.974,4.974,0,0,0-.8,0l-2.8-6.88Zm-23.8,6.531a1.889,1.889,0,0,1,1.551-.1,2.23,2.23,0,0,1,.926,1.317l.283,1.219.406-.094,6.88,16.812-9.3-2.233-2.122,8.84-5.14-1.234-7.947-19.049C1537.4,967.563,1545.9,964.4,1548.66,963.281Zm11.325,22.279.358-.146,5.057,1.214-1.534,6.392L1556.3,991.2h0l-2.447-.588h0l-4.131-.992,1.534-6.392,8.619,2.069Zm-17.013,5.033,8.017,1.925h0l2.281.547-.893,3.72-10.3-2.472Zm12.745,3.059,7.561,1.815-.893,3.72-7.561-1.815Zm-23.9-21.756.833-.3,7.8,18.7-.351,1.46Zm12.533,25.55,17.447,4.188-1.33,5.57-16.394-3.937h0l-.953-.227Zm-3.345,7.677,4.953,1.189-1.386,5.775-4.953-1.189Zm45.3,16.981-4.542-1.09.865-3.6,4.542,1.09Zm-6.124-5.282-.865,3.6-5.522-1.325.72-2.861-2.441-.614-1.313,5.22-2.047-2.03-2.786.646,1.238-5.158-2.448-.587-.728,3.031-16.968-4.073,1.386-5.775,11.467,2.752-.227.947a1.259,1.259,0,0,0,.93,1.517Zm-14.192-32.642-4.267-1.024-8.479-20.72c-.041-.2-.14-.862.306-1.082.974-.481,9.085-3.433,14.956-5.536l3.645,8.945a4.6,4.6,0,0,0-1.887,2.256,1.253,1.253,0,0,0-.285.544Zm33.109-11.4-22.074-5.3-.588,2.447,22.146,5.316a5.935,5.935,0,0,0,.058.769L1574.6,970.24a3.042,3.042,0,0,1-1.67-1.011,1.472,1.472,0,0,1-.342-1.212,2.072,2.072,0,0,1,1.007-1.187,2.614,2.614,0,0,1,1.9-.3l23.888,5.734A4.948,4.948,0,0,0,1599.1,972.776Z",
    transform: "translate(-1528.474 -952.635)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1574",
    "data-name": "Rectangle 1574",
    width: 2.665,
    height: 2.517,
    transform: "translate(44.692 23.421) rotate(-76.498)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1575",
    "data-name": "Rectangle 1575",
    width: 2.818,
    height: 2.517,
    transform: "matrix(0.233, -0.972, 0.972, 0.233, 42.659, 31.894)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1576",
    "data-name": "Rectangle 1576",
    width: 2.818,
    height: 2.517,
    transform: "translate(41.642 36.13) rotate(-76.502)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1577",
    "data-name": "Rectangle 1577",
    width: 2.818,
    height: 2.517,
    transform: "matrix(0.233, -0.972, 0.972, 0.233, 43.676, 27.658)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1578",
    "data-name": "Rectangle 1578",
    width: 2.818,
    height: 2.517,
    transform: "translate(37.574 53.076) rotate(-76.5)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1579",
    "data-name": "Rectangle 1579",
    width: 2.818,
    height: 2.517,
    transform: "translate(38.591 48.839) rotate(-76.502)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1580",
    "data-name": "Rectangle 1580",
    width: 2.818,
    height: 2.517,
    transform: "translate(40.625 40.367) rotate(-76.504)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1581",
    "data-name": "Rectangle 1581",
    width: 2.818,
    height: 2.517,
    transform: "translate(39.608 44.603) rotate(-76.507)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1582",
    "data-name": "Rectangle 1582",
    width: 2.665,
    height: 2.517,
    transform: "translate(36.593 57.164) rotate(-76.5)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1583",
    "data-name": "Rectangle 1583",
    width: 2.748,
    height: 2.517,
    transform: "translate(18.832 49.879) rotate(-76.506)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1584",
    "data-name": "Rectangle 1584",
    width: 2.537,
    height: 2.517,
    transform: "translate(22.943 50.866) rotate(-76.502)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1585",
    "data-name": "Rectangle 1585",
    width: 2.517,
    height: 19.219,
    transform: "translate(49.441 32.865) rotate(-76.502)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1586",
    "data-name": "Rectangle 1586",
    width: 2.517,
    height: 19.219,
    transform: "matrix(0.233, -0.972, 0.972, 0.233, 48.108, 38.415)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1587",
    "data-name": "Rectangle 1587",
    width: 12.25,
    height: 2.517,
    transform: "translate(29.431 14.284) rotate(-20.343)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1588",
    "data-name": "Rectangle 1588",
    width: 12.25,
    height: 2.517,
    transform: "translate(27.888 11.269) rotate(-20.343)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1589",
    "data-name": "Rectangle 1589",
    width: 12.25,
    height: 2.517,
    transform: "translate(11.135 20.763) rotate(-20.342)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1590",
    "data-name": "Rectangle 1590",
    width: 12.25,
    height: 2.517,
    transform: "translate(9.592 17.748) rotate(-20.344)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13980",
    "data-name": "Group 13980",
    transform: "translate(-1771.41 -1278.588)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60725",
    "data-name": "Path 60725",
    d: "M2561.042,1655.339l-21.956-42.44a1.548,1.548,0,0,0-.911-.768,1.572,1.572,0,0,0-1.187.1l-2.141,1.108-.977-1.888a.4.4,0,0,0-.539-.172l-9.537,4.934a.4.4,0,0,0-.172.539l1.063,2.055a.4.4,0,0,0,.539.172l7.128-3.687,19.9,38.47-25.875,13.386-19.174-37.065,1.129-2.483,5.774-2.987a.4.4,0,0,0,.171-.539l-1.063-2.054a.4.4,0,0,0-.539-.172l-6.608,3.419a.4.4,0,0,0-.18.19l-1.393,3.063-3.257-.479-.026-.011a.4.4,0,0,0-.235,0,.4.4,0,0,0-.158.07l-.009.008-6.541,3.384a.4.4,0,0,0-.172.539l1.063,2.054a.4.4,0,0,0,.539.172l5.843-3.023,2.978.438,19.094,36.909-25.875,13.386-19.9-38.47,7.531-3.9a.4.4,0,0,0,.172-.539l-1.063-2.054a.4.4,0,0,0-.54-.172l-9.94,5.142a.4.4,0,0,0-.171.539l.708,1.37-1.969,1.018a1.557,1.557,0,0,0-.668,2.1l22.135,42.787a1.557,1.557,0,0,0,1.382.84c.039,0,.078,0,.116,0a1.548,1.548,0,0,0,.6-.17l28.305-14.643a5.3,5.3,0,0,0,2.3.525c.132,0,.266,0,.4-.015a5.362,5.362,0,0,0,4.831-4.187l28.411-14.7A1.558,1.558,0,0,0,2561.042,1655.339Zm-30.708,14.135a1.562,1.562,0,0,0-1.358,1.528,2.236,2.236,0,0,1-3.54,1.8,1.541,1.541,0,0,0-1.538-.152,1.571,1.571,0,0,0-.4.139l-27.418,14.185-20.7-40.021.587-.3,20.256,39.154a.4.4,0,0,0,.539.172l28.639-14.816h0l30.695-15.88a.4.4,0,0,0,.172-.539l-19.988-38.636.759-.393,20.525,39.675Z",
    transform: "translate(-0.249 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60726",
    "data-name": "Path 60726",
    d: "M2888.552,1748.808a1.555,1.555,0,0,0,1.18,2.571c.039,0,.076,0,.115,0a1.557,1.557,0,1,0-1.295-2.566Z",
    transform: "translate(-331.016 -108.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60727",
    "data-name": "Path 60727",
    d: "M2882.706,1733.094a1.556,1.556,0,1,0-1.015,2.734c.039,0,.077,0,.115,0a1.555,1.555,0,0,0,.9-2.729Z",
    transform: "translate(-324.629 -96.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60728",
    "data-name": "Path 60728",
    d: "M2836.052,1642.672a1.557,1.557,0,1,0-2.765,1.431l7.637,14.763a1.551,1.551,0,0,0,1.383.841c.038,0,.077,0,.116,0a1.556,1.556,0,0,0,1.266-2.267Z",
    transform: "translate(-287.284 -24.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60729",
    "data-name": "Path 60729",
    d: "M2473.983,1833.877a1.555,1.555,0,0,0-2.568,1.293,1.553,1.553,0,0,0,1.553,1.44c.039,0,.077,0,.116,0a1.555,1.555,0,0,0,.9-2.729Z",
    transform: "translate(0 -176.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60730",
    "data-name": "Path 60730",
    d: "M2482.022,1849.424a1.547,1.547,0,0,0-1.132-.374,1.557,1.557,0,0,0,.116,3.109c.039,0,.077,0,.115,0a1.556,1.556,0,0,0,.9-2.731Z",
    transform: "translate(-6.385 -188.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60731",
    "data-name": "Path 60731",
    d: "M2498.545,1886.059c.039,0,.077,0,.115,0a1.556,1.556,0,0,0,1.266-2.268l-7.637-14.763a1.557,1.557,0,1,0-2.765,1.43l7.638,14.764A1.553,1.553,0,0,0,2498.545,1886.059Z",
    transform: "translate(-14.248 -204.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60732",
    "data-name": "Path 60732",
    d: "M2575.215,1627.164a19.7,19.7,0,0,0-9.4-6.16,1.556,1.556,0,1,0-.878,2.986,16.609,16.609,0,0,1,7.979,5.269,1.073,1.073,0,0,1,.845,1.127l7.961,15.388a1.553,1.553,0,0,0,1.384.842c.038,0,.077,0,.115,0l.045-.006a1.55,1.55,0,0,0,.78.213c.039,0,.077,0,.116,0a1.553,1.553,0,0,0,.471-.111c.241-.1.482-.209.717-.331a8.722,8.722,0,0,0,3.739-11.755l-1.966-3.8a8.665,8.665,0,0,0-5.1-4.3,8.807,8.807,0,0,0-1.755-.366,1.534,1.534,0,0,0-.108-.2,22.325,22.325,0,0,0-39.473,20.45,1.551,1.551,0,0,0,.364.535,8.755,8.755,0,0,0-.378.976,8.667,8.667,0,0,0,.564,6.652l1.966,3.8a8.7,8.7,0,0,0,7.761,4.713c.216,0,.434-.008.649-.024a8.659,8.659,0,0,0,3.346-.95c.235-.122.465-.254.683-.394a1.547,1.547,0,0,0,.683-.976,1.576,1.576,0,0,0,.029-.2,1.559,1.559,0,0,0,.211-1.738L2548.6,1643.4a1.552,1.552,0,0,0-1.166-.826.285.285,0,0,1-.189-.388c-1.705-7.1,1.255-14.21,7.2-17.285a13.611,13.611,0,0,1,3.893-1.317,1.556,1.556,0,1,0-.541-3.066,16.729,16.729,0,0,0-4.782,1.617c-7.219,3.734-10.835,12.278-8.795,20.777a1.539,1.539,0,0,0,.092.27,8.709,8.709,0,0,0-1.167.882,19.206,19.206,0,0,1,33.615-17.561,8.751,8.751,0,0,0-1.388.571C2575.316,1627.106,2575.266,1627.137,2575.215,1627.164Zm1.731,2.609a5.531,5.531,0,0,1,2.421-.558,5.625,5.625,0,0,1,4.988,3.034l1.965,3.8a5.608,5.608,0,0,1-2.259,7.479Zm-23.575,29.632a5.53,5.53,0,0,1-2.417.554,5.6,5.6,0,0,1-4.992-3.031l-1.966-3.8a5.608,5.608,0,0,1,2.259-7.479Z",
    transform: "translate(-53.716 -3.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60733",
    "data-name": "Path 60733",
    d: "M2642.95,1639.165a1.557,1.557,0,0,0-.052,3.1,1.6,1.6,0,0,0,.2.013c.039,0,.077,0,.116,0a1.555,1.555,0,0,0,1.368-2.022A1.573,1.573,0,0,0,2642.95,1639.165Z",
    transform: "translate(-135.101 -22.179)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13981",
    "data-name": "Group 13981",
    transform: "translate(-2523.428 -859.078) rotate(-20)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60734",
    "data-name": "Path 60734",
    d: "M3140.172,2395.915a.26.26,0,0,0,.125.154l2.305,1.245a.26.26,0,0,0,.124.031.271.271,0,0,0,.075-.011.264.264,0,0,0,.154-.126l.622-1.152a12.813,12.813,0,0,0,1.515-7.051l-.1-1.307a.262.262,0,0,0-.278-.241l-2.613.193a.26.26,0,0,0-.24.279l.1,1.306a9.7,9.7,0,0,1-1.146,5.328l-.623,1.152A.26.26,0,0,0,3140.172,2395.915Z",
    transform: "translate(-229.709 -162.682)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60735",
    "data-name": "Path 60735",
    d: "M3078.5,2375.437l-8.1-1.882a1.571,1.571,0,0,0-1.852,2l2.716,8.549a1.567,1.567,0,0,0,1.206,1.068,1.584,1.584,0,0,0,.292.027,1.542,1.542,0,0,0,.474-.074,1.561,1.561,0,0,0,.746-.51l5.385-6.667a1.57,1.57,0,0,0-.866-2.515Zm-3.151,2.491-1.976,2.447-1-3.138Z",
    transform: "translate(-170.807 -151.225)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60736",
    "data-name": "Path 60736",
    d: "M2960.5,2233.208a2.449,2.449,0,0,0-1.862-.155l-52,16.507a2.4,2.4,0,0,0-1.586,2.993l12.439,39.185a2.373,2.373,0,0,0,2.281,1.646,2.455,2.455,0,0,0,.743-.115l7.812-2.481a1.477,1.477,0,1,0-.893-2.816l-7.3,2.316-12.084-38.072,50.977-16.183,3.537,11.142,5.794,18.25a1.473,1.473,0,0,0,1.408,1.031,1.5,1.5,0,0,0,.448-.07,1.48,1.48,0,0,0,.96-1.856c-1.8-5.665-4.174-13.152-6.1-19.222l-3.338-10.512a2.1,2.1,0,0,0-.073-.209l.006,0A2.332,2.332,0,0,0,2960.5,2233.208Z",
    transform: "translate(-36.427 -35.714)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60737",
    "data-name": "Path 60737",
    d: "M3049.167,2533.648a1.458,1.458,0,0,0-1.189.623,1.479,1.479,0,0,0,1.148,2.41,1.5,1.5,0,0,0,.448-.07l.07-.025.008,0c.024-.006.046-.012.071-.02a1.477,1.477,0,0,0,.095-2.784A1.776,1.776,0,0,0,3049.167,2533.648Z",
    transform: "translate(-153.692 -282.805)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60738",
    "data-name": "Path 60738",
    d: "M3245.692,2487.085a1.487,1.487,0,0,0-1.081-.469,1.478,1.478,0,0,0-1.08,2.487c.42.449,1.541,1.685,1.577,1.725a1.478,1.478,0,0,0,2.087.1,1.479,1.479,0,0,0,.1-2.091c-.011-.011-.079-.086-.181-.2C3246.76,2488.251,3246.025,2487.442,3245.692,2487.085Z",
    transform: "translate(-314.321 -244.159)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60739",
    "data-name": "Path 60739",
    d: "M3284.252,2467.026a1.478,1.478,0,0,0-1.054,2.514c.483.492.76.782.784.808l.006.006a1.478,1.478,0,0,0,1.519.387,1.438,1.438,0,0,0,.571-.339,1.477,1.477,0,0,0,.051-2.088s-.3-.32-.82-.846A1.469,1.469,0,0,0,3284.252,2467.026Z",
    transform: "translate(-346.892 -228.062)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60740",
    "data-name": "Path 60740",
    d: "M2959.323,2258.674l-.161-3.487c-.091-2-3.162-7.093-4.518-8.554l-9.5-10.213-13.575-42.764a5.906,5.906,0,0,0-5.612-4.184,5.626,5.626,0,0,0-1.707.266l-59.644,18.933h0a5.879,5.879,0,0,0-3.714,7.421l14.188,44.695a6,6,0,0,0,2.865,3.484,5.77,5.77,0,0,0,2.736.7,5.679,5.679,0,0,0,1.718-.268l28.218-8.96a1.477,1.477,0,1,0-.895-2.816l-28.219,8.958a2.764,2.764,0,0,1-2.152-.217,3.057,3.057,0,0,1-1.455-1.778l-14.188-44.7a2.921,2.921,0,0,1,1.8-3.711l59.644-18.932a2.685,2.685,0,0,1,.814-.126,3,3,0,0,1,2.793,2.121l11.937,37.605a5,5,0,0,0-5.486.868,5.437,5.437,0,0,0-1.349,1.914,4.9,4.9,0,0,0-2.277-.548,5.388,5.388,0,0,0-3.667,1.46,5.6,5.6,0,0,0-1.486,2.358,5.408,5.408,0,0,0-2.358-.49h-.021a5.96,5.96,0,0,0-5.642,4l-6.939-7.5a5.354,5.354,0,0,0-3.973-1.709,6.02,6.02,0,0,0-5.766,4.473l-.788-.134a9.725,9.725,0,1,1,7.289-17.482l1.064.763a.26.26,0,0,0,.363-.059l1.527-2.129a.259.259,0,0,0-.059-.363l-1.064-.764a13.007,13.007,0,0,0-7.525-2.41,12.859,12.859,0,0,0-2.119,25.539l1.291.219a.237.237,0,0,0,.044,0,.263.263,0,0,0,.061-.01,5.271,5.271,0,0,0,1.145,1.944l4.552,4.911-8.677,2.757a1.477,1.477,0,1,0,.895,2.816l8.741-2.776a1.474,1.474,0,0,0,.9-.8l5.351,5.772a1.462,1.462,0,0,0-.057,1.075c2.033,6.073,6.025,16.589,9.919,18.787a18.953,18.953,0,0,0,6.886,1.878l.458.066a1.474,1.474,0,0,0,.558.15l7.294.49c.025,0,.049,0,.073,0a1.461,1.461,0,0,0,.131.172l3.25,3.616a1.479,1.479,0,0,0,2.2-1.977l-3.251-3.616a1.48,1.48,0,0,0-1.072-.488,1.445,1.445,0,0,0-.118-.156,1.464,1.464,0,0,0-1.013-.5l-6.686-.451a1.533,1.533,0,0,0-.289-.073c-.362-.055-.729-.106-1.1-.157l-.04-.006a16.735,16.735,0,0,1-5.83-1.523c-1.749-.988-4.345-5.746-6.933-12.56l3.115,3.361a1.478,1.478,0,0,0,2.168-2.011l-19.257-20.77a2.422,2.422,0,0,1-.621-1.885,3.063,3.063,0,0,1,2.992-2.748,2.425,2.425,0,0,1,1.805.761l10.206,11.009,0,0,3.918,4.228.069.072.174.188a1.478,1.478,0,0,0,2.168-2.01l-.067-.072a1.493,1.493,0,0,0-.108-.12l-3.613-3.894-.376-.407a2.721,2.721,0,0,1,.347-3.813,2.987,2.987,0,0,1,2.037-.818,2.434,2.434,0,0,1,1.8.767l.516.551a1.467,1.467,0,0,0,.448.325c.063.107.129.213.2.317a1.481,1.481,0,0,0,1.211.63,1.46,1.46,0,0,0,.446-.069,1.478,1.478,0,0,0,.765-2.257,2.209,2.209,0,0,1,.479-2.835,2.444,2.444,0,0,1,1.658-.676,1.852,1.852,0,0,1,1.38.576l1.247,1.337a1.477,1.477,0,0,0,2.279-1.871,1.447,1.447,0,0,0,0-.5,1.932,1.932,0,0,1,.729-1.691,2.024,2.024,0,0,1,1.378-.539h.07a1.949,1.949,0,0,1,1.385.624l2.48,2.668.19.6a1.47,1.47,0,0,0,1.319,1.024l8.44,9.076a23.409,23.409,0,0,1,3.73,6.677l.2,4.27a.26.26,0,0,0,.085.181.256.256,0,0,0,.109.056,1.473,1.473,0,0,0,.327.6l3.9,4.339a1.478,1.478,0,0,0,2.575-.91,1.464,1.464,0,0,0-.376-1.066Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13983",
    "data-name": "Group 13983",
    transform: "translate(2301.691 -2169.857) rotate(49)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60745",
    "data-name": "Path 60745",
    d: "M1088.6,2802.573c.035,0,.066.008.1.008h0c.011,0,.023-.009.034-.009.028,0,.055-.008.083-.01s.05,0,.075-.007c.041,0,.082-.012.122-.02l.049-.009a1.752,1.752,0,0,0,.339-.106l.025-.013a1.724,1.724,0,0,0,.181-.094l.067-.042c.047-.031.093-.065.137-.1.018-.014.037-.027.054-.042a1.829,1.829,0,0,0,.135-.13l.03-.032.013-.014,15.8-16.936a1.789,1.789,0,0,0,.355-1.865l-2.95-7.513,6.905-6.464a1.812,1.812,0,0,0,.318-.4l.053.136a1.779,1.779,0,0,0,2.3,1.015l.06-.024a1.774,1.774,0,0,0,.956-2.28l-3.012-7.759a1.781,1.781,0,1,0-3.32,1.289l1.949,5.021a1.8,1.8,0,0,0-.516-.079l-31.486-.161a1.779,1.779,0,0,0-1.218.479l-24.449,22.814a1.781,1.781,0,0,0,1.193,3.083l8.5.106,3.019,7.695a1.768,1.768,0,0,0,1.721,1.129c.01,0,.988-.034,2.149-.034,1.032,0,1.887.026,2.54.077.032,0,.064,0,.1,0a8.71,8.71,0,0,0,.6,2.437c.983,2.552,1.892,4.489,1.93,4.57a1.78,1.78,0,0,0,2.25.9l3.191-1.226.066-.027a1.78,1.78,0,0,0,.959-2.275s-.4-1.051-.78-2.009c-.258-.657-.5-1.246-.722-1.775.795.059,1.584.123,2.353.182C1084.984,2802.376,1087.564,2802.573,1088.6,2802.573Zm-13.094-4.723a2.979,2.979,0,0,0-.813-.214,1.78,1.78,0,0,0-1.757-2.071,1.743,1.743,0,0,0-.7.143,1.782,1.782,0,0,0-1.185,2.012c-.726-.052-1.629-.078-2.693-.078-.359,0-.7,0-1,.007l-2.035-5.187,3.749.047.8,2.112a1.779,1.779,0,0,0,2.3,1.031l.072-.029a1.776,1.776,0,0,0,.96-2.269l-.4-1.039a1.764,1.764,0,0,0,.885.251l9.856.123a1.785,1.785,0,0,0,.118.547c.609,1.559,1.549,3.84,2.293,5.627-1.363-.093-3.075-.223-4.839-.357l-3.135-.236a1.776,1.776,0,0,0-1.3.433A3.426,3.426,0,0,0,1075.51,2797.85Zm11.033-6.571,13.912-13.023,2.022,5.15-13.2,14.146c-.733-1.76-1.681-4.06-2.286-5.61A1.782,1.782,0,0,0,1086.543,2791.279Zm-12.37-2.268,8.655-9.082a1.781,1.781,0,1,0-2.578-2.457l-10.939,11.478-11.84-.149,20.689-19.305,26.3.135-20.83,19.5Z",
    transform: "translate(0 -87.274)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60746",
    "data-name": "Path 60746",
    d: "M1216.673,2866.7a4.945,4.945,0,0,0,2.762,2.778,5.211,5.211,0,0,0,1.991.4,5.139,5.139,0,0,0,1.884-.357l27.652-10.848c.052-.02.1-.041.153-.063a4.953,4.953,0,0,0,2.615-2.624,5.047,5.047,0,0,0,.045-3.837l-11.471-29.24a1.571,1.571,0,0,1-.323-.822l-.874-2.391a1.787,1.787,0,0,0-1.673-1.17,1.781,1.781,0,0,0-1.672,2.393l.875,2.391a1.862,1.862,0,0,1,.352.9l11.471,29.241a1.5,1.5,0,0,1-.007,1.144,1.417,1.417,0,0,1-.79.764l-27.653,10.848a1.675,1.675,0,0,1-1.219-.018,1.419,1.419,0,0,1-.8-.784l-5.73-14.607a1.781,1.781,0,1,0-3.316,1.3Z",
    transform: "translate(-125.165 -134.175)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60747",
    "data-name": "Path 60747",
    d: "M1303.864,2741.471a1.777,1.777,0,0,0,2.326,1l.036-.014a1.773,1.773,0,0,0,.954-2.286l-.084-.215a1.781,1.781,0,1,0-3.316,1.3Z",
    transform: "translate(-197.976 -71.667)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60748",
    "data-name": "Path 60748",
    d: "M1133.87,2700.907l27.653-10.848a1.356,1.356,0,0,1,.5-.095,1.449,1.449,0,0,1,1.322.934,1.41,1.41,0,0,1,.3.625l1.757,4.576a1.792,1.792,0,0,0,1.663,1.143,1.773,1.773,0,0,0,.636-.118l.067-.027a1.775,1.775,0,0,0,.959-2.274l-1.757-4.577a1.767,1.767,0,0,0-.255-.449,1.791,1.791,0,0,0-.094-.294,5.026,5.026,0,0,0-4.6-3.1,4.889,4.889,0,0,0-1.792.341l-27.652,10.847a5.145,5.145,0,0,0-2.824,2.718,4.968,4.968,0,0,0-.125,3.869l1.982,5.132a1.778,1.778,0,0,0,2.3,1.019l.06-.025a1.775,1.775,0,0,0,.958-2.278l-1.985-5.14A1.593,1.593,0,0,1,1133.87,2700.907Z",
    transform: "translate(-61.22 -30.553)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60749",
    "data-name": "Path 60749",
    d: "M1265.739,2930.524a1.781,1.781,0,0,0-1.353-3.294l-26.045,10.2a1.781,1.781,0,1,0,1.3,3.316l26.045-10.2Z",
    transform: "translate(-145.862 -219.335)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60750",
    "data-name": "Path 60750",
    d: "M1296.037,2974.585a1.776,1.776,0,0,0-.65.123l-8.393,3.293a1.781,1.781,0,1,0,1.3,3.316l8.394-3.293.053-.021a1.781,1.781,0,0,0-.7-3.417Z",
    transform: "translate(-184.021 -256.571)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60751",
    "data-name": "Path 60751",
    d: "M1215.011,3015.182a1.808,1.808,0,0,0-.371.039,12.906,12.906,0,0,0-1.7.547,10.254,10.254,0,0,1-3.051.789,1.909,1.909,0,0,1-.537-.068c-1.127-.334-1.894-1.7-2.437-2.847-1.143-2.421-2.13-4.93-3.085-7.358-.512-1.3-1.04-2.645-1.59-3.967a1.781,1.781,0,0,0-3.288,1.369c.528,1.269,1.049,2.593,1.553,3.874l.011.028c.976,2.481,1.985,5.048,3.179,7.575.859,1.821,2.164,4,4.644,4.74a5.44,5.44,0,0,0,1.548.214,12.666,12.666,0,0,0,4.293-1.01,11.437,11.437,0,0,1,1.2-.4,1.822,1.822,0,0,0,.335-.106,1.781,1.781,0,0,0-.7-3.417Z",
    transform: "translate(-115.748 -277.461)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60752",
    "data-name": "Path 60752",
    d: "M1291.149,3054.378a1.781,1.781,0,0,0-1.349-3.3l-3.922,1.524a1.781,1.781,0,1,0,1.29,3.319l3.923-1.524Z",
    transform: "translate(-183.141 -316.472)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60753",
    "data-name": "Path 60753",
    d: "M1273.477,2661.879a1.779,1.779,0,0,0,2.318.982l.036-.015a1.789,1.789,0,0,0,.947-2.3l-.291-.718c-1.186-2.929-2.211-5.459-3.542-8.21a6.794,6.794,0,0,0-6.508-4.167,16.094,16.094,0,0,0-5.369,1.162,1.778,1.778,0,0,0-1.066,2.282,1.777,1.777,0,0,0,2.282,1.066,12.92,12.92,0,0,1,4.2-.943,3.249,3.249,0,0,1,3.254,2.151c1.281,2.648,2.285,5.127,3.447,8Z",
    transform: "translate(-163.653 0)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60754",
    "data-name": "Path 60754",
    d: "M1230.95,2664.059a1.768,1.768,0,0,0,.694-.141l2.775-1.176a1.781,1.781,0,0,0-1.4-3.276l-2.775,1.176a1.781,1.781,0,0,0,.7,3.417Z",
    transform: "translate(-139.556 -9.316)",
    fill: "#fffefd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60755",
    "data-name": "Path 60755",
    d: "M1209.221,2676.815a1.829,1.829,0,0,0,.7-.14l.023-.01a1.829,1.829,0,0,0,1.1-1.81c0-.049-.009-.1-.017-.148a1.771,1.771,0,0,0-.87-1.48,1.8,1.8,0,0,0-1.667-.083,1.767,1.767,0,0,0-1.185,1.259,1.79,1.79,0,0,0,.461,1.692c.023.03.047.059.071.088A1.826,1.826,0,0,0,1209.221,2676.815Z",
    transform: "translate(-122.368 -20.025)",
    fill: "#fffefd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13984",
    "data-name": "Group 13984",
    transform: "translate(837.48 297.438)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60706",
    "data-name": "Path 60706",
    d: "M1681.552,1672.11a1.729,1.729,0,0,0,.04.44l7.092,31.073a1.722,1.722,0,0,0,2.286,1.226,42.434,42.434,0,0,1,9.32-2.119,28.845,28.845,0,0,0-5.555,1.714,33.068,33.068,0,0,0-6.136,3.391l-7.505-32.884a1.721,1.721,0,0,0-3.355.766l8.106,35.516a2.445,2.445,0,0,0,3.442.4c.1-.091,10.661-9.029,22.533-4.829a1.721,1.721,0,0,0,2.2-1.048c.007-.021.012-.042.019-.063a1.753,1.753,0,0,0,.235.211,1.721,1.721,0,0,0,2.406-.362c6.859-9.289,21.947-4.757,22.1-4.71a1.712,1.712,0,0,0,.892.033l.023,0c.019,0,.037-.011.056-.016l.05-.014a1.72,1.72,0,0,0,1.188-2.031l-8.106-35.516a1.721,1.721,0,0,0-3.355.766l7.493,32.829a35.534,35.534,0,0,0-6.855-.651,24.555,24.555,0,0,0-8.077,1.316,19.152,19.152,0,0,1,10.786-1.7,2.23,2.23,0,0,0,1.808-2.62l-7.279-31.892a1.721,1.721,0,0,0-2.06-1.295c-.042.01-.083.022-.124.035l-.033,0c-12.2,1.677-17.918,6.221-19.888,8.2-9.782-2.572-22.1,1.814-22.623,2.005A1.72,1.72,0,0,0,1681.552,1672.11Zm42.854-8.439,6.528,28.6a20.861,20.861,0,0,0-13.76,4.36,19.4,19.4,0,0,0-2.878,2.825l-6.562-28.749C1709.169,1669.276,1713.933,1665.354,1724.406,1663.671Zm-20,7.932,6.551,28.7c-6.98-2.507-15.6-.44-19.34.7l-6.376-27.938C1688.619,1672.048,1697.456,1669.782,1704.407,1671.6Z",
    transform: "translate(-1660.924 -1641.718)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60707",
    "data-name": "Path 60707",
    d: "M1987.913,1666.205l1.5,6.563a1.721,1.721,0,1,0,3.355-.766l-1.5-6.563a1.709,1.709,0,0,1-.221-.969l-7.138-31.276a6.374,6.374,0,0,0-1.538-2.908,1.721,1.721,0,1,0-2.525,2.338,2.887,2.887,0,0,1,.707,1.336l7.138,31.276a1.705,1.705,0,0,1,.221.969Z",
    transform: "translate(-1902.657 -1617.474)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60708",
    "data-name": "Path 60708",
    d: "M1724.485,1639.208a1.721,1.721,0,0,0,1.673,1.328,1.741,1.741,0,0,0,.395-.046c.324-.076,32.472-7.618,41.715-9.728a1.721,1.721,0,1,0-.766-3.355c-9.252,2.112-41.411,9.656-41.734,9.732A1.721,1.721,0,0,0,1724.485,1639.208Z",
    transform: "translate(-1698.377 -1615.574)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60709",
    "data-name": "Path 60709",
    d: "M1851.592,1859.71l-.718-3.146a1.721,1.721,0,0,0-2.182-1.262c-.8.21-11.25,2.587-18.143,4.148a1.721,1.721,0,1,0,.76,3.356c9.891-2.24,14.458-3.284,16.6-3.784l.331,1.454a2.9,2.9,0,0,1-2.309,3.493l-50.378,11.5a1.721,1.721,0,1,0,.766,3.355l50.378-11.5A6.335,6.335,0,0,0,1851.592,1859.71Zm-2.912-4.4a1.539,1.539,0,0,0-.155.058A1.1,1.1,0,0,1,1848.68,1855.3Z",
    transform: "translate(-1754.283 -1798.15)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60710",
    "data-name": "Path 60710",
    d: "M1621.281,1689.967a6.389,6.389,0,0,0-.886,4.924l6.309,27.646a1.713,1.713,0,0,1,.387,1.693l2.271,9.952,3.355-.765-2.271-9.953a1.709,1.709,0,0,1-.386-1.693l-6.31-27.646a2.925,2.925,0,0,1,.422-2.269,3.184,3.184,0,0,1,1.955-1.355h0s.006-.023.008-.024c.458-.1,2.251-.525,8.323-1.91a1.725,1.725,0,0,0-.766-3.363l-8.406,1.917h-.006l-.05.011h0l-.046.012A6.579,6.579,0,0,0,1621.281,1689.967Z",
    transform: "translate(-1614.881 -1661.882)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60711",
    "data-name": "Path 60711",
    d: "M1704.166,1888.155a1.721,1.721,0,1,0-.766-3.355l-52.723,12.033c-1.75.4-3.127.84-3.95,1.1-.2.064-.424.136-.526.165a1.72,1.72,0,0,0-1.4,2.08l.663,2.9a6.223,6.223,0,0,0,2.878,3.994,6.431,6.431,0,0,0,3.32.913,6.83,6.83,0,0,0,1.519-.173l19.894-4.541a1.72,1.72,0,1,0-.766-3.355l-19.894,4.541a3.108,3.108,0,0,1-2.3-.336,2.813,2.813,0,0,1-1.294-1.809l-.306-1.34c.755-.234,1.757-.525,2.926-.792Z",
    transform: "translate(-1634.534 -1821.812)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60712",
    "data-name": "Path 60712",
    d: "M1953.179,1880.074c-.057.009-.113.021-.168.036a1.72,1.72,0,0,0-.827,2.967,1.823,1.823,0,0,0,1.238.5,1.757,1.757,0,0,0,1.729-2.079A1.72,1.72,0,0,0,1953.179,1880.074Z",
    transform: "translate(-1880.404 -1818.042)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60713",
    "data-name": "Path 60713",
    d: "M1698.561,1682.547a1.7,1.7,0,0,0,.011.195,1.72,1.72,0,0,0,1.709,1.528,1.738,1.738,0,0,0,1.737-1.724,1.721,1.721,0,0,0-2.1-1.677l.367,1.681-.383-1.677A1.721,1.721,0,0,0,1698.561,1682.547Z",
    transform: "translate(-1677.642 -1658.409)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60714",
    "data-name": "Path 60714",
    d: "M1742.755,1626.032a1.716,1.716,0,0,0,.385-.044l1.425-.325a1.721,1.721,0,0,0-.766-3.355l-1.425.325a1.721,1.721,0,0,0,.381,3.4Z",
    transform: "translate(-1711.675 -1611.487)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60715",
    "data-name": "Path 60715",
    d: "M1774.977,1608a1.705,1.705,0,0,0,.385-.044c1.735-.4,3.336-.851,5.032-1.334,1.9-.539,3.854-1.1,6.234-1.64a1.721,1.721,0,0,0-.765-3.355c-2.469.563-4.472,1.134-6.41,1.685-1.651.47-3.211.914-4.857,1.289a1.721,1.721,0,0,0,.381,3.4Z",
    transform: "translate(-1737.493 -1594.913)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60716",
    "data-name": "Path 60716",
    d: "M1857.574,1591.934a1.72,1.72,0,0,0,.385-.043l10-2.283a1.721,1.721,0,0,0-.766-3.355l-10,2.283a1.721,1.721,0,0,0,.381,3.4Z",
    transform: "translate(-1803.675 -1582.598)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60717",
    "data-name": "Path 60717",
    d: "M1651.226,1634.8a2.226,2.226,0,1,0-2.569-1.819A2.225,2.225,0,0,0,1651.226,1634.8Z",
    transform: "translate(-1637.63 -1617.99)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60718",
    "data-name": "Path 60718",
    d: "M1741.294,2040.885l-2.748-1.81a1.721,1.721,0,0,0-2.374.477L1735,2041.3l-2.039-1.157a1.72,1.72,0,0,0-2.3.57l-1.01,1.579-.984-.6a1.721,1.721,0,1,0-1.8,2.931l2.425,1.491a1.72,1.72,0,0,0,2.35-.539l1.042-1.63,2.007,1.139a1.721,1.721,0,0,0,2.277-.537l1.11-1.653,1.324.871a1.72,1.72,0,1,0,1.893-2.873Z",
    transform: "translate(-1699.664 -1945.234)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60719",
    "data-name": "Path 60719",
    d: "M2051.287,1746.882c0,.005,0,.011,0,.016s0,.015.005.022l.056.247a1.721,1.721,0,1,0,3.354-.767l-.037-.161c0-.005,0-.01,0-.016l-.086-.379a1.721,1.721,0,0,0-3.355.765l.05.216h0Z",
    transform: "translate(-1960.183 -1709.435)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60720",
    "data-name": "Path 60720",
    d: "M2041.6,1688.828a1.721,1.721,0,1,0-3.355.766l1.126,4.925a1.72,1.72,0,1,0,3.354-.766Z",
    transform: "translate(-1949.785 -1663.75)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60721",
    "data-name": "Path 60721",
    d: "M1622.175,1894.639l-.086-.378a1.721,1.721,0,0,0-3.355.766l.046.2,0,.013h0v0l.033.147v0l.043.19a1.721,1.721,0,0,0,3.355-.767l-.037-.162Z",
    transform: "translate(-1613.644 -1828.355)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60722",
    "data-name": "Path 60722",
    d: "M1605.562,1829.636a1.721,1.721,0,0,0-1.295,2.06l.417,1.824c.666,2.918,1.284,5.625,1.392,6.1a1.721,1.721,0,0,0,3.354-.768c-.108-.471-.726-3.177-1.391-6.093l-.417-1.825A1.721,1.721,0,0,0,1605.562,1829.636Z",
    transform: "translate(-1602.053 -1777.611)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60723",
    "data-name": "Path 60723",
    d: "M1596.7,1783.086a1.721,1.721,0,0,0-3.355.767c.073.317.843,3.693,1.236,5.416a1.721,1.721,0,0,0,1.676,1.338,1.746,1.746,0,0,0,.384-.043,1.72,1.72,0,0,0,1.295-2.06C1597.542,1786.78,1596.772,1783.4,1596.7,1783.086Z",
    transform: "translate(-1593.301 -1739.276)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60724",
    "data-name": "Path 60724",
    d: "M1966.463,1570.655a8.779,8.779,0,0,0-8.654-2.332l-3.25.743a1.721,1.721,0,1,0,.767,3.355l3.25-.743a5.364,5.364,0,0,1,5.427,1.383,11.394,11.394,0,0,1,2.611,5.369l1.844,8.066a1.721,1.721,0,1,0,3.355-.767l-1.844-8.066A14.881,14.881,0,0,0,1966.463,1570.655Z",
    transform: "translate(-1881.691 -1568.035)",
    fill: "#fff"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60756",
    "data-name": "Path 60756",
    d: "M2987.944,955.248a12.321,12.321,0,0,0,.081,10.473l2.574,5.373a12.415,12.415,0,0,0,11.146,7.008,12.211,12.211,0,0,0,5.314-1.211c.334-.16.665-.337.983-.526a2.373,2.373,0,0,0,.53-.43c.049-.02.1-.037.146-.061a2.364,2.364,0,0,0,1.109-3.15l-10.723-22.384a2.372,2.372,0,0,0-1.666-1.29c-.037-.028-.074-.055-.112-.081a2.434,2.434,0,0,0-.041-.333c-2.052-9.872,2.329-19.551,10.652-23.538a18.725,18.725,0,0,1,7.623-1.838,2.038,2.038,0,0,1,3.56.277h.01a2.383,2.383,0,0,0,.335.024,2.333,2.333,0,0,0,1.017-.231c.071-.034.142-.072.225-.122a2.41,2.41,0,0,0,.305-.226,2.354,2.354,0,0,0,1.425,1.3,22.926,22.926,0,0,1,10.789,7.61,1.572,1.572,0,0,1,1.107,1.569l8.4,17.544a2.3,2.3,0,0,0-.04.459c0,.255-.117,6.089-7.116,9.826a6.679,6.679,0,0,0-4.58-1.836,6.568,6.568,0,0,0-2.858.65l-4.76,2.28a6.644,6.644,0,0,0-3.119,8.852l.04.084a6.678,6.678,0,0,0,5.994,3.769,6.562,6.562,0,0,0,2.859-.651l4.76-2.279a6.644,6.644,0,0,0,3.731-6.622,18.05,18.05,0,0,0,8.456-8.619,2.326,2.326,0,0,0,2.1.038c.049-.024.1-.051.143-.078a2.359,2.359,0,0,0,.662-.141c.344-.128.689-.275,1.027-.436a12.354,12.354,0,0,0,5.8-16.46l-2.574-5.374a12.421,12.421,0,0,0-9.366-6.876l-.132-.22A31.285,31.285,0,0,0,2987.6,954.32Zm60.436-3.4-9.145-19.09a7.512,7.512,0,0,1,2.888-.574,7.666,7.666,0,0,1,6.883,4.326l2.574,5.373A7.628,7.628,0,0,1,3048.38,951.848Zm-52.891,1.875,9.141,19.082a7.511,7.511,0,0,1-2.888.573,7.666,7.666,0,0,1-6.883-4.325l-2.574-5.374a7.612,7.612,0,0,1,3.2-9.957Zm23.949-34.888a2.4,2.4,0,0,0-1.034.231,1.58,1.58,0,0,1-2.906-.527h-.065a23.405,23.405,0,0,0-9.535,2.3c-10.288,4.928-15.731,16.754-13.236,28.758a2.223,2.223,0,0,0,.07.255,12.266,12.266,0,0,0-1.322.932A26.552,26.552,0,0,1,3038.535,928a12.48,12.48,0,0,0-1.729.672c-.027.013-.052.028-.08.041a27.6,27.6,0,0,0-12.813-8.915,2.344,2.344,0,0,0-2.282.464c-.012-.029-.022-.058-.036-.086-.034-.069-.071-.137-.119-.216A2.374,2.374,0,0,0,3019.438,918.836Zm13.417,47.976a1.9,1.9,0,0,1-.977,1.091l-4.758,2.28a1.89,1.89,0,0,1-.822.187,1.927,1.927,0,0,1-1.73-1.086l-.04-.084a1.917,1.917,0,0,1,.9-2.552l4.76-2.28a1.887,1.887,0,0,1,.822-.187,1.926,1.926,0,0,1,1.73,1.084l.041.086A1.9,1.9,0,0,1,3032.856,966.812Z",
    transform: "translate(-2178.912 -490.223)",
    fill: "#fff",
    opacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeToTrainingBg);
export default __webpack_public_path__ + "static/media/welcomeToTrainingBG.112b54ecfa4fdcf359167b6eede30f88.svg";
export { ForwardRef as ReactComponent };